import React, { FC } from 'react';
import { Panel } from '@component/Panel';
import {
    OrderPartsHelpContents,
    Title,
    Paragraph,
} from './OrderPartsHelpContents';
import { SakuraIcon } from './SakuraIcon';
import { OrderPartsHelpProps } from './type';
import { handleKeyPress } from './handleKeyPress';

const ZERO_JPN = 250;

interface Props {
    className?: string;
}

export const ZeroInner: FC<Props> = ({ className }) => (
    <OrderPartsHelpContents className={className}>
        <Title>
            <SakuraIcon />
            ZERO流
        </Title>
        <Paragraph>
            さらなる飛貫中の実現のために長年の研究により生みだされた技術です。
            独自技術ため詳細は紹介できませんが矢飛びの向上を体感いただけます。
            ぜひお試しください。（￥
            {ZERO_JPN}
            ／1本）
        </Paragraph>
    </OrderPartsHelpContents>
);

export const OrderPartsHelpZero: FC<OrderPartsHelpProps> = ({
    isOpen,
    handleClose,
}) => (
    <Panel isOpen={isOpen} onRequestClose={handleClose}>
        <div
            className="order-parts-help-panel-close"
            onClick={handleClose}
            onKeyPress={handleKeyPress(handleClose)}
            role="button"
            tabIndex="0"
        >
            <i className="icon-close" />
        </div>
        <div className="order-parts-help-panel">
            <div className="scrollable">
                <ZeroInner />
            </div>
        </div>
    </Panel>
);
